import type { FiltroEnvios, FiltroOrcamentoIa } from '@nexital/shared';
import type { ApiConfiguracoes } from '../application/portas-configuracoes';
import type { ApiHttp } from './api-http';

/** Cliente das Configurações da empresa (ADR-0022), sobre a chamada autenticada do ApiHttp. */
export function criarApiConfiguracoes(api: ApiHttp, empresaUuid: string): ApiConfiguracoes {
  const base = `/api/empresas/${empresaUuid}/configuracoes`;
  const nada = async (p: Promise<unknown>) => {
    await p;
  };
  const multipart = (campos: Record<string, string | null | undefined>, arquivo: File) => {
    const f = new FormData();
    for (const [k, v] of Object.entries(campos)) if (v !== null && v !== undefined) f.append(k, v);
    f.append('arquivo', arquivo, arquivo.name);
    return f;
  };
  /** Filtro dos envios na URL; listas vão separadas por vírgula. */
  const consulta = (filtro: FiltroEnvios | FiltroOrcamentoIa) => {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(filtro)) if (v !== undefined && v !== '' && !(Array.isArray(v) && v.length === 0)) q.set(k, String(v));
    const texto = q.toString();
    return texto ? `?${texto}` : '';
  };
  return {
    acesso: () => api.chamar('GET', base),
    empresa: () => api.chamar('GET', `${base}/empresa`),
    salvarEmpresa: (dados) => nada(api.chamar('PUT', `${base}/empresa`, dados)),
    enviarLogo: (arquivo) => api.chamar('POST', `${base}/empresa/logo`, multipart({}, arquivo)),
    documentos: () => api.chamar('GET', `${base}/documentos`),
    enviarDocumento: (d, arquivo) =>
      nada(api.chamar('POST', `${base}/documentos`, multipart({ nome: d.nome, tipo: String(d.tipo), emitidoEm: d.emitidoEm, validoAte: d.validoAte, observacao: d.observacao }, arquivo))),
    urlDocumento: (uuid) => api.chamar('GET', `${base}/documentos/${uuid}/arquivo`),
    excluirDocumento: (uuid, motivo) => nada(api.chamar('DELETE', `${base}/documentos/${uuid}`, { motivo })),
    usuarios: () => api.chamar('GET', `${base}/usuarios`),
    bloquear: (uuid, motivo) => nada(api.chamar('POST', `${base}/usuarios/${uuid}/bloquear`, { motivo })),
    desbloquear: (uuid) => nada(api.chamar('POST', `${base}/usuarios/${uuid}/desbloquear`, {})),
    quadros: () => api.chamar('GET', `${base}/quadros`),
    criarQuadro: (dados) => nada(api.chamar('POST', `${base}/quadros`, dados)),
    alterarQuadro: (uuid, dados) => nada(api.chamar('PUT', `${base}/quadros/${uuid}`, dados)),
    arquivarQuadro: (uuid, motivo) => nada(api.chamar('DELETE', `${base}/quadros/${uuid}`, { motivo })),
    estados: (quadroUuid) => api.chamar('GET', `${base}/quadros/${quadroUuid}/estados`),
    criarEstado: (quadroUuid, dados) => nada(api.chamar('POST', `${base}/quadros/${quadroUuid}/estados`, dados)),
    alterarEstado: (uuid, dados) => nada(api.chamar('PUT', `${base}/estados/${uuid}`, dados)),
    ordenarEstados: (quadroUuid, uuids) => nada(api.chamar('PUT', `${base}/quadros/${quadroUuid}/estados/ordem`, { uuids })),
    excluirEstado: (uuid) => nada(api.chamar('DELETE', `${base}/estados/${uuid}`)),
    padroes: () => api.chamar('GET', `${base}/padroes`),
    salvarPadroes: (dados) => nada(api.chamar('PUT', `${base}/padroes`, dados)),
    envios: (filtro) => api.chamar('GET', `${base}/envios${consulta(filtro)}`),
    envio: (uuid) => api.chamar('GET', `${base}/envios/${uuid}`),
    reenviar: (entrada) => api.chamar('POST', `${base}/envios/reenviar`, entrada),
    orcamentoIa: (filtro) => api.chamar('GET', `${base}/orcamento-ia${consulta(filtro)}`),
  };
}
